// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "container-3uX9C";
var _5 = "container_rounded-1BthT";
var _6 = "tabs__container_center-3KPjb";
var _7 = "tabs__container_right-2zn3w";
var _8 = "tab__indicator-34OjJ";
var _9 = "tab-3MEYq";
var _a = "tab_rounded-3zl-5";
var _b = "tab_selected-3jvuX";
var _c = "tab_disabled-2Irkp";
var _d = "tab__content-IuK80";
var _e = "route-LVFCt";
var _f = "desc-2bR4R";
var _10 = "seats__count-3fHNV";
var _11 = "scroller-2czgZ";
export { _1 as "__esModule", _2 as "tablet", _3 as "mobile", _4 as "container", _5 as "container_rounded", _6 as "tabs__container_center", _7 as "tabs__container_right", _8 as "tab__indicator", _9 as "tab", _a as "tab_rounded", _b as "tab_selected", _c as "tab_disabled", _d as "tab__content", _e as "route", _f as "desc", _10 as "seats__count", _11 as "scroller" }
export default { "__esModule": _1, "tablet": _2, "mobile": _3, "container": _4, "container_rounded": _5, "tabs__container_center": _6, "tabs__container_right": _7, "tab__indicator": _8, "tab": _9, "tab_rounded": _a, "tab_selected": _b, "tab_disabled": _c, "tab__content": _d, "route": _e, "desc": _f, "seats__count": _10, "scroller": _11 }
